import { forwardRef } from 'react'
import { BetsCycleLoader } from '@/components/ui/betscycle-loader'
import { getCasinoGameImageUrl } from '@/lib/casino'
import { cn } from '@/lib/utils'
import type { CasinoGame } from '@/types/casino'
import { Button } from '@/components/ui/button'

interface CasinoPlayHeroProps {
	game: CasinoGame
	gameUrl: string | null
	isLaunching: boolean
	isTheaterMode: boolean
	onRealPlay: () => void
	onDemoPlay: () => void
}

export const CasinoPlayHero = forwardRef<HTMLDivElement, CasinoPlayHeroProps>(function CasinoPlayHero({ game, gameUrl, isLaunching, isTheaterMode, onRealPlay, onDemoPlay }, ref) {
	const imageUrl = getCasinoGameImageUrl(game)

	return (
		<div
			ref={ref}
			className={cn(
				'relative w-full scroll-mt-20 overflow-hidden rounded-2xl border border-border bg-card lg:scroll-mt-4',
				isTheaterMode ? 'aspect-[21/9] min-h-[620px]' : 'aspect-video min-h-[400px] sm:min-h-[520px] lg:min-h-[640px]',
			)}
		>
			{gameUrl ? (
				<iframe
					key={`${game.id}-${gameUrl}`}
					src={gameUrl}
					title={game.casino_name}
					className='absolute inset-0 h-full w-full border-0'
					allow='autoplay; fullscreen; encrypted-media'
					allowFullScreen
				/>
			) : (
				<>
					<img src={imageUrl} alt='' aria-hidden className='absolute inset-0 h-full w-full scale-110 object-cover blur-2xl' />
					<div className='absolute inset-0 bg-background/70' />

					<div className='relative flex h-full items-center justify-center p-6'>
						{isLaunching ? (
							<div className='flex flex-col items-center gap-3 text-foreground'>
								<BetsCycleLoader size={40} />
								<p className='text-sm font-medium text-muted-foreground'>Launching game...</p>
							</div>
						) : (
							<div className='flex flex-col items-center gap-3 sm:flex-row sm:gap-4'>
								<Button variant='primary' size='lg' onClick={onRealPlay}>
									Real Play
								</Button>
								<Button variant='secondary' size='lg' onClick={onDemoPlay}>
									Demo Play
								</Button>
							</div>
						)}
					</div>
				</>
			)}
		</div>
	)
})
